import React from 'react';
import styles from './TreatmentsProtocolsCalculator.module.scss';
import api from '../../../helpers/api';
import SkinTypeSelector from '../../miscellaneous/SkinTypeSelector/SkinTypeSelector';
import { $t } from '../../../helpers/translator';

import MultiSelect from '../../miscellaneous/MultiSelect/MultiSelect';
import { GiElectric, GiRadiations } from 'react-icons/gi';
import Loader from '../../miscellaneous/Loader/Loader';
import _ from "lodash";

class ClinicTreatmentsProtocolsCalculator extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            payload: {
                area_id: 1,
                grid_id: 1,
                hairType: 2,
                handle_id: 1,
                recommended: 1,
                skinType: 2,
            },

            recommendedTreatmentParameters: null,

            loading: false,

            handleOptions: [],
            handleSelected: null,

            areaOptions: [],
            areaSelected: null,

            hairTypeOptions: [ {
                label: $t('global.treatments.sparse'),
                value: 1
            }, {
                label: $t('global.treatments.coarse'),
                value: 2
            } ],
            hairTypeSelected: null,
        };
    }

    async componentDidMount() {
        await this.init();
    }

    async init() {
        this.setState({ loading: true }, async () => {
            try {
                // let res = await api.fetchApplicatorTypes();
                let res = await api.get('/general/applicators');
                if (res && res.data && res.data.data) {
                    let applicators = [];
                    _.forEach(res.data.data, (v) => {
                        v.label = v.handle_type_name;
                        v.value = v.id;
                        // console.log(v)
                        applicators.push(v);
                    });
                    this.setState({
                        handleOptions: applicators,
                        handleSelected: applicators[ 0 ],
                        hairTypeSelected: this.state.hairTypeOptions[ 0 ]
                    });
                }

                // res = await api.fetchTreatmentReccomandation();
                res = await api.get('/treatments/recommendations');
                if (res && res.data && res.data.data) {
                    let areas = [];
                    _.forEach(res.data.data, (v) => {
                        v.label = $t('global.areas.' + v.name);
                        v.value = v.area_id;
                        areas.push(v);
                    });

                    this.setState({
                        areaOptions: areas,
                        areaSelected: areas[ 0 ]
                    });
                }
            } catch (e) {
                console.error('err getting handle types', e);
            } finally {
                this.setState({ loading: false });
            }
        });
    }

    async getTreatmentProtocol() {
        this.setState({ loading: true }, async () => {
            try {
                let res = await api.get(`/treatments/recommended?area_id=${this.state.payload.area_id}&grid_id=${this.state.payload.grid_id}&hairType=${this.state.payload.hairType}&handle_id=${this.state.payload.handle_id}&recommended=${this.state.payload.recommended}&skinType=${this.state.payload.skinType}`);
                // console.log('recommended  res:', res);
                if (res && res.data && res.data.data) {
                    this.setState({ recommendedTreatmentParameters: res.data.data });
                }
            } catch (e) {
                console.error('err getting recommended', e);
            } finally {
                this.setState({ loading: false });
            }
        });
    }

    changeSkinType(data) {
        let payload = { ...this.state.payload };
        payload.skinType = data.value;
        this.setState({ payload: payload }, async () => {
            await this.getTreatmentProtocol();
        });
    }

    fieldChangeHandler(fieldName, data) {
        this.setState({ [ fieldName + 'Selected' ]: null }, () => {
            let payload = { ...this.state.payload };

            if (fieldName === 'handle') {
                payload.handle_id = data.value;
            }
            if (fieldName === 'hairType') {
                payload.hairType = data.value;
            }
            if (fieldName === 'area') {
                payload.area_id = data.value;
            }

            this.setState({
                [ fieldName + 'Selected' ]: this.state[ fieldName + 'Options' ][ data.key ],
                payload: payload
            }, async () => await this.getTreatmentProtocol());
        });
    }

    render() {
        return (
            <div className={ `${styles[ 'container' ]}` }>
                <div className={ `${styles[ 'flex-row' ]} ${styles[ 'flex-wrap' ]}` }>
                    <div style={ { width: '100%' } }>
                        <div className={ `${styles[ 'flex-row' ]}` }>
                            <div className={ `${styles[ 'filter' ]}` }>
                                <div className={ `${styles[ 'filter-name' ]}` }>{ $t('global.treatments.area') }</div>
                                <div className={ `${styles[ 'select' ]}` }>
                                    <MultiSelect
                                        options={ this.state.areaOptions }
                                        selected={ this.state.areaSelected }
                                        onValueChange={ (data) => this.fieldChangeHandler('area', data) }
                                    />
                                </div>
                            </div>
                            <div className={ `${styles[ 'circles-container' ]}` }>
                                { this.state.areaSelected && this.state.areaSelected.image ?
                                    <div className={ `${styles[ 'flex-row' ]} ${styles[ 'center' ]}` }>
                                        <div className={ `${styles[ 'image-container' ]}` }
                                            style={ {
                                                background: 'url(\'' + this.state.areaSelected.image + '\')  50% 0% no-repeat',
                                                backgroundSize: 'cover',
                                                position: 'relative',
                                            } }
                                        >
                                            {/*<img src={this.state.areaSelected.image} alt=""/>*/ }
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>

                        <div className={ `${styles[ 'flex-row' ]}` }>
                            <div className={ `${styles[ 'filter' ]}` }>
                                <div className={ `${styles[ 'filter-name' ]}` }>{ $t('global.treatments.handleType') }</div>
                                <div className={ `${styles[ 'select' ]}` }>
                                    <MultiSelect
                                        options={ this.state.handleOptions }
                                        selected={ this.state.handleSelected }
                                        onValueChange={ (data) => this.fieldChangeHandler('handle', data) }
                                    />
                                </div>
                            </div>
                            <div className={ `${styles[ 'circles-container' ]}` }>
                                { this.state.handleSelected && this.state.handleSelected.image ?
                                    <div className={ `${styles[ 'flex-row' ]} ${styles[ 'center' ]}` }>
                                        <div className={ `${styles[ 'image-container' ]}` }
                                            style={ {
                                                background: 'url(\'' + this.state.handleSelected.image + '\')  50% 0% no-repeat',
                                                backgroundSize: 'cover',
                                                position: 'relative',
                                            } }
                                        >
                                            {/*<img src={this.state.handleSelected.image} alt=""/>*/ }
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                            </div>
                        </div>

                        <div className={ `${styles[ 'filter' ]}` }>
                            <div className={ `${styles[ 'filter-name' ]}` }>{ $t('global.treatments.hairDensity') }</div>
                            <div className={ `${styles[ 'select' ]}` }>
                                <MultiSelect
                                    options={ this.state.hairTypeOptions }
                                    selected={ this.state.hairTypeSelected }
                                    onValueChange={ (data) => this.fieldChangeHandler('hairType', data) }
                                />
                            </div>
                        </div>

                        <div className={ `${styles[ 'filter' ]}` }>
                            <div className={ `${styles[ 'filter-name' ]}` }>{ $t('global.treatments.skinType') }</div>
                            <SkinTypeSelector skinType={ this.state.payload.skinType }
                                onValueChange={ (data) => this.changeSkinType(data) } />
                        </div>
                    </div>

                    <div className={ `${styles[ 'recommended-response-container-out' ]}` }>
                        { this.state.loading ?
                            <div className={ `${styles[ 'loader-container' ]}` }>
                                <Loader />
                            </div>
                            :
                            null
                        }

                        <div className={ `${styles[ 'recommended-response-container' ]}` }>
                            <div className={ `${styles[ 'recommended-response-header' ]}` }>
                                { $t('global.treatments.recommendedTreatmentParameters') }
                            </div>
                            <div className={ `${styles[ 'rec-settings-container' ]}` }>
                                <div className={ `${styles[ 'rec-setting-container' ]}` }>
                                    <div className={ `${styles[ 'rec-setting-icon' ]}` }>
                                        <GiRadiations />
                                    </div>
                                    <div className={ `${styles[ 'rec-setting-texts' ]}` }>
                                        <div className={ `${styles[ 'rec-setting-name' ]}` }>{ $t('global.machines.fluence') }</div>
                                        <div
                                            className={ `${styles[ 'rec-setting-value' ]}` }>{ this.state.recommendedTreatmentParameters ? this.state.recommendedTreatmentParameters.fluence : '' }</div>
                                    </div>
                                </div>

                                <div className={ `${styles[ 'rec-setting-container' ]}` }>
                                    <div className={ `${styles[ 'rec-setting-icon' ]}` }>
                                        <GiElectric />
                                    </div>
                                    <div className={ `${styles[ 'rec-setting-texts' ]}` }>
                                        <div className={ `${styles[ 'rec-setting-name' ]}` }>{ $t('global.machines.energy') }</div>
                                        <div
                                            className={ `${styles[ 'rec-setting-value' ]}` }>{ this.state.recommendedTreatmentParameters ? this.state.recommendedTreatmentParameters.energy : '' }</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClinicTreatmentsProtocolsCalculator;
